import React, { memo } from 'react';

export const GradiantBox = memo(({ color1, color2, children }) => {
  return (
    <div
      style={{
        background: `linear-gradient(${color1}, ${color2})`,
      }}
    >
      {children}
    </div>
  );
});
